export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sort_asc.b152a670.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};